// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2tScq","alert":"SettungsInbox_alert__IRdSy"};